import * as React from 'react';
import { CodeStatus } from '../../../../../../api/PropertyIntegration';

interface Props {
    status: CodeStatus;
}

const ManualAccessStatusDisplay = (props: Props) => {
    let statusDisplay = '';
    switch (props.status) {
        case CodeStatus.Active:
            statusDisplay = 'Active';
            break;
        case CodeStatus.Removed:
            statusDisplay = 'Removed';
            break;
        case CodeStatus.InUse:
            statusDisplay = 'In Use';
            break;
        case CodeStatus.Used:
            statusDisplay = 'Used';
            break;
        default:
            statusDisplay = 'Unknown';
            break;
    }
    return <span className="code-display">{statusDisplay}</span>;
};

export default ManualAccessStatusDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/manualAccessControls/ManualAccessStatusDisplay.tsx